import { render, staticRenderFns } from "./prescriptionDetails.vue?vue&type=template&id=d19bfac8&scoped=true&"
import script from "./prescriptionDetails.vue?vue&type=script&lang=js&"
export * from "./prescriptionDetails.vue?vue&type=script&lang=js&"
import style0 from "./prescriptionDetails.vue?vue&type=style&index=0&id=d19bfac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19bfac8",
  null
  
)

export default component.exports